'use strict'

const propTypes = require('prop-types');
const React = require('react')
const { object, string } = propTypes
const createReactClass = require('create-react-class');

const DiscountAlert = createReactClass({
  propTypes: {
    agentData: object,
    pageName: string
  },

  getInitialState () {
    return {
      visible: true
    }
  },

  getMessage () {
    const { agentData, pageName } = this.props

    if (pageName && pageName.indexOf('email') > -1) {
      return 'Your email discount has been applied'
    }

    if ( parseInt( agentData.promocode, 10 ) || agentData.agent === 'BE140' ) {
      return 'Your discount code has been applied';
    }

    if (parseInt(agentData.cashback, 10)) {
      return 'Your cashback code has been applied'
    }
  },

  closeAlert () {
    this.setState({
      visible: false
    })
  },

  render () {
    const { visible } = this.state
    const message = this.getMessage( )
    if ( !( visible && message )) return null
    return (
      <div id='discountAlert' className='custom-alert alert'>
        <button type='button' className='close' onClick={this.closeAlert}>X</button>
        <h4>
          <span>{ message }</span>
        </h4>
      </div>
    )
  }
})

module.exports = DiscountAlert





// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/discount-alert.jsx